import React from 'react';

interface ICheckProps {
	size?: string;
	fill?: string;
	className?: string;
}

export const Check = ({ size = '20', fill, className = '' }: ICheckProps) => (
	<svg aria-hidden="true" width={size} height={size} viewBox="0 0 20 20" fill="none" className={className}>
		<path
			d="M8.72886 14.1667L8.09386 14.9392C8.30668 15.1141 8.58223 15.1935 8.8555 15.1586C9.12877 15.1237 9.37554 14.9777 9.53758 14.7549L8.72886 14.1667ZM14.5873 4.4118L7.92015 13.5785L9.53758 14.7549L16.2048 5.5882L14.5873 4.4118ZM9.36386 13.3942L4.80175 9.64415L3.53175 11.1892L8.09386 14.9392L9.36386 13.3942Z"
			fill={fill || '#121212'}
		/>
	</svg>
);
